/* ==========================================================================
   AKRO - Accordeons du pied de panier : « Free samples » et « Discount code »
   --------------------------------------------------------------------------
   Voir l'en-tete de assets/akro-cart-accordion.css pour le pourquoi.

   Ce fichier fait trois choses :
   1. Au clic sur un en-tete, ecrire sur <html> quel bloc est ouvert
      (`data-akro-cart-open`). Un seul attribut pour deux blocs : ouvrir l'un
      ferme l'autre par construction, il n'y a aucun cas a gerer.
   2. Resynchroniser `aria-expanded` apres chaque re-rendu du panier. Le theme
      remplace le HTML du pied a chaque evenement et le repose a « false » ;
      l'affichage, lui, ne depend que de <html> et ne clignote donc pas.
   3. « Free samples » est ouvert par defaut (attribut pose cote serveur dans
      layout/theme.liquid, reglable dans AKRO – Panier). Si le client le
      REFERME LUI-MEME, on s'en souvient pour le reste de sa visite
      (sessionStorage) : il ne se rouvre plus a chaque page. Le rouvrir efface
      ce souvenir. Ouvrir le code promo ne compte pas comme une fermeture - le
      client n'a pas rejete les echantillons, il voulait saisir un code.

   PHASE DE CAPTURE, OBLIGATOIRE : le tiroir porte un @click.stop sur
   #right-drawer-slot. Un ecouteur en phase bubble ne verrait jamais les clics
   du panier deroulant.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__akroCartAccordionReady) return;
  window.__akroCartAccordionReady = true;

  var ATTR = 'data-akro-cart-open';
  var DISMISSED_KEY = 'akro_samples_closed';
  var root = document.documentElement;

  /* sessionStorage peut etre indisponible (navigation privee stricte,
     stockage bloque) : chaque acces est protege, et sans stockage le seul
     effet est que le bloc se rouvre a la page suivante. */
  function isDismissed() {
    try {
      return window.sessionStorage.getItem(DISMISSED_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function setDismissed(value) {
    try {
      if (value) window.sessionStorage.setItem(DISMISSED_KEY, '1');
      else window.sessionStorage.removeItem(DISMISSED_KEY);
    } catch (e) {
      /* rien : voir ci-dessus */
    }
  }

  /* Le client a deja referme les echantillons pendant cette visite : on
     annule l'ouverture par defaut posee par le serveur. Execute des le
     chargement du script, tiroir encore ferme : rien ne se voit. */
  if (root.getAttribute(ATTR) === 'samples' && isDismissed()) {
    root.removeAttribute(ATTR);
  }

  function current() {
    return root.getAttribute(ATTR) || '';
  }

  function sync() {
    var cur = current();
    var toggles = document.querySelectorAll('[data-akro-acc-toggle]');
    for (var i = 0; i < toggles.length; i++) {
      var open = toggles[i].getAttribute('data-akro-acc-toggle') === cur;
      toggles[i].setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  }

  function setOpen(name) {
    if (name) root.setAttribute(ATTR, name);
    else root.removeAttribute(ATTR);
    sync();
  }

  /* A l'ouverture du code promo, le curseur se place dans le champ - mais
     uniquement avec une souris. Sur telephone, cela ferait surgir le clavier
     et sauter la page alors que le client voulait peut-etre juste regarder. */
  var finePointer = window.matchMedia
    ? window.matchMedia('(hover: hover) and (pointer: fine)')
    : null;

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var toggle = target.closest('[data-akro-acc-toggle]');
      if (!toggle) return;

      event.preventDefault();

      var name = toggle.getAttribute('data-akro-acc-toggle');
      var opening = current() !== name;
      setOpen(opening ? name : '');

      /* Seul un geste sur l'en-tete des echantillons eux-memes compte. */
      if (name === 'samples') setDismissed(!opening);

      if (opening && name === 'promo' && finePointer && finePointer.matches) {
        var block = toggle.closest('[data-akro-acc]');
        var input = block && block.querySelector('[data-akro-promo-input]');
        if (input) {
          window.setTimeout(function () {
            try {
              input.focus({ preventScroll: true });
            } catch (e) {
              input.focus();
            }
          }, 0);
        }
      }
    },
    true
  );

  /* Les trois evenements panier du theme : chacun re-rend le pied. */
  ['baseline:cart:update', 'baseline:cart:cartqtychange', 'baseline:cart:afteradditem'].forEach(
    function (name) {
      window.addEventListener(name, function () {
        window.setTimeout(sync, 0);
      });
    }
  );

  /* Le contenu du tiroir n'est insere dans la page qu'a l'initialisation du
     theme, apres ce script : la synchro du chargement ne le trouve pas. Le
     theme emet `cart-will-open` juste avant chaque ouverture du tiroir - on
     resynchronise a ce moment-la. */
  document.addEventListener('cart-will-open', sync);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
